module.exports = {"id":"189923","name":"Costa Nhamoinesu","rating":"72","photo":"./data/images/photos/3/189923.png","club":{"name":"Sparta Prague","logo":"./data/images/clubs/SpartaPrague.png"},"positions":["DG","DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/CostaNhamoinesu0.json
// module id = 856
// module chunks = 0